"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLoading = isLoading;
exports.isSuccess = isSuccess;
exports.isError = isError;
function isLoading(state) {
    return state.status === 'loading';
}
function isSuccess(state) {
    return state.status === 'success';
}
function isError(state) {
    return state.status === 'error';
}
//# sourceMappingURL=async-state.js.map